<template>
  <div class="create-new-sku2">
    <div class="breadcrumb" style="background: #fff">创建SKU组</div>
    <div class="third-title">SKU组</div>
    <div class="order-detail-basic">
      <div class="data-list">
        <el-table :data="skuList" border :row-class-name="RowClassName">
          <el-table-column label="sku组名称" prop="skuGroupName" min-width="100px">
          </el-table-column>
          <el-table-column v-for="item in tableColumns" :key="item.id" :label="item.propKey" :prop="item.propKey" min-width="100px"></el-table-column>
          <el-table-column v-for="item in attrNameList" :key="item.id" :label="item.key" min-width="100px">
            <template v-slot="scope"> {{ scope.row[item.key] }} </template>
          </el-table-column>
          <el-table-column label="SKU组图片" min-width="100px">
            <template v-slot="scope">
              <div class="show_img" style="width: 100%">
                <img :src="scope.row.skuGroupImage" alt="" style="max-width: 100%">
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column min-width="100px" label="统一关联尺寸组">
            <template slot-scope="scope">
              <span class="color-blue" @click="choiceSizeGroup('skuGroup'), nowSkuGroupIndex = scope.row.index">绑定尺寸组</span>
            </template>
          </el-table-column> -->
          <el-table-column min-width="100px" label="SKU设置">
            <template v-slot="scope">
              <!-- 判断单sku组产品  || addSkuGroupStepTwoVo.skuGroups[scope.row.index].skus.length === 0-->
              <span class="color-blue" @click="addSku(scope.row.index)">添加SKU<br></span>
              <span class="color-blue" @click="setSku(scope.row.index)">管理SKU</span>
            </template>
          </el-table-column>
          <el-table-column min-width="100px">
            <template slot="header">
              <span>样品价格</span>
              <span class="color-blue" style="padding: 0 5px;font-size: 12px;font-weight: normal" @click="samplePriceDialog = true">统一设置</span>
            </template>
            <template slot-scope="scope">
              <el-input @input="changeItemSamplePrice(addSkuGroupStepTwoVo.skuGroups[scope.row.index])" v-model="addSkuGroupStepTwoVo.skuGroups[scope.row.index].samplePrice"></el-input>
            </template>
          </el-table-column>
          <el-table-column min-width="100px" v-if="$route.query.startupsSpu && $route.query.showPoint == 'true'">
            <template slot="header">
              <span>样品积分价格</span>
              <span class="color-blue" style="padding: 0 5px;font-size: 12px;font-weight: normal" @click="samplePointsDialog = true">统一设置</span>
            </template>
            <template slot-scope="scope">
              <input class="elinput" @input="changeItemSamplePoints(addSkuGroupStepTwoVo.skuGroups[scope.row.index])" v-model="addSkuGroupStepTwoVo.skuGroups[scope.row.index].samplePoints" />
            </template>
          </el-table-column>
          <el-table-column min-width="100px">
            <template slot="header">
              <span>在线支付样品价格<br></span>
              <span class="color-blue" style="padding: 0 5px;font-size: 12px;font-weight: normal" @click="onlineSamplePriceDialog = true">统一设置</span>
            </template>
            <template slot-scope="scope">
              <el-input v-model="addSkuGroupStepTwoVo.skuGroups[scope.row.index].onlineSamplePrice"></el-input>
            </template>
          </el-table-column>
          <el-table-column min-width="100px" v-if="startupsSpu == 'true'">
            <template slot="header">
              <span>初创平台样品价格<br></span>
              <span class="color-blue" style="padding: 0 5px;font-size: 12px;font-weight: normal" @click="startupsSamplePriceDialog = true">统一设置</span>
            </template>
            <template slot-scope="scope">
              <el-input v-model="addSkuGroupStepTwoVo.skuGroups[scope.row.index].startupsSamplePrice"></el-input>
            </template>
          </el-table-column>
          <el-table-column min-width="100px">
            <template slot="header">
              <span>样品主题</span>
              <!-- <span class="color-blue" style="padding: 0 5px;font-size: 12px;font-weight: normal"
                @click="sampleThemeDialog=true,themeType='all',themeTabelData=allThemeTableData">统一添加</span> -->
            </template>
            <template slot-scope="scope">
              <span class="color-blue" @click="sampleThemeDialog = true, themeType = 'single', nowSkuGroupIndex = scope.row.index, setThemeTableData()">编辑样品主题</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="edit-button">
      <el-button @click="onSubmit" round type="primary">创建sku组</el-button>
    </div>
    <!-- 绑定尺寸组 -->
    <el-dialog :close-on-click-modal="false" title="绑定尺寸组" :visible.sync="sizeDialog" @closed="searchComposeSizeGroupVO = { groupCategoryId: '', groupName: '', userId: $store.state.user.userId }"
      width="60%">
      <el-form :inline="true" :model="searchComposeSizeGroupVO" class="demo-form-inline">
        <el-form-item label="尺寸组类:">
          <el-select v-model="searchComposeSizeGroupVO.groupCategoryId" placeholder="请选择尺寸组类" clearable>
            <el-option v-for="item in sizeGroupTypeList" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="尺寸组名称：">
          <el-input v-model="searchComposeSizeGroupVO.groupName" placeholder="请输入尺寸组名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getSizeGroupList">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="sizeGroupList" border>
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div style="width:100%;height:100%;background:red">
              <el-table :data="scope.row.detail.sizeList" border>
                <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                <el-table-column label="页面类型" prop="typeName">
                  <template slot-scope="scope"> {{ scope.row.spuPageName.pageTypeCode === 'COVER' ? '封面' : scope.row.spuPageName.pageTypeCode === 'TEXT' ? '内页' : scope.row.spuPageName.pageTypeCode ===
                    'SINGLE' ? '单页' : '未定义' }} </template>
                </el-table-column>
                <el-table-column label="页面名称" prop="pageName"></el-table-column>
                <el-table-column label="宽高">
                  <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
                </el-table-column>
                <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                <el-table-column label="出血" width="220px">
                  <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{ scope.row.bleed.bleedRight
                  }}mm <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
                </el-table-column>
                <el-table-column label="码" prop="barCodeId">
                  <template slot-scope="scope">
                    <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尺寸组名称" min-width="100px" prop="groupName"></el-table-column>
        <el-table-column label="尺寸组类" prop="groupCategoryName" min-width="100px"></el-table-column>
        <el-table-column label="页面名称" prop="detail.pageName" min-width="100px">
          <template slot-scope="scope"> {{ scope.row.pageName.substring(0, scope.row.pageName.length - 1) }} </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100px">
          <template slot-scope="scope">
            <span class="color-blue" @click="relation(scope.row)">选择</span><br>
          </template>
        </el-table-column>
      </el-table>
      <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sizeDialog = false">取 消</el-button>
        <el-button type="primary" @click="sizeDialog = false" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加sku -->
    <el-dialog :close-on-click-modal="false" title="SKU设置" :visible.sync="addSkuDialog" width="800px" @closed="beforeClose" @opened="$refs.formaaa.clearValidate()">
      <el-form ref="formaaa" v-show="addSkuStep === 1" :rules="step1Rules" :model="skuMsg" label-width="180px">
        <el-form-item label="SKU名称：" prop="skuName">
          <el-input v-model="skuMsg.skuName" maxlength="40" placeholder="" style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="SKU前端显示名称：" prop="skuFrontName">
          <el-input v-model="skuMsg.skuFrontName" maxlength="40" placeholder="" style="width:300px;"></el-input>
        </el-form-item>
        <el-form-item label="尺寸组：">
          <span v-if="skuMsgName">{{ skuMsgName }}</span>
          <el-button type="primary" style="margin-left:20px" @click="choiceSizeGroup('sku')" round>选择尺寸组</el-button>
        </el-form-item>
        <el-form-item label="页面名称：">
          <el-table :data="pageNameTableData" style="width: 500px">
            <el-table-column prop="pageName" label="页面名称"></el-table-column>
            <el-table-column prop="typeName" label="页面类型">
              <template slot-scope="scope"> {{ scope.row.spuPageName.pageTypeCode === 'COVER' ? '封面' : scope.row.spuPageName.pageTypeCode === 'TEXT' ? '内页' : scope.row.spuPageName.pageTypeCode ===
                'SINGLE' ? '单页' : '未定义' }} </template>
            </el-table-column>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <span v-if="!scope.row.isEditable">{{ scope.row.pageNum }}</span>
                <el-input v-if="scope.row.isEditable" @input="countP" style="width:100px" v-model="scope.row.pageNum" placeholder=""></el-input>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="用户应上传照片张数 :" prop="uploadPhotoNum" v-if="skuMsg.spuType == 'photo'">
          <el-input v-model="skuMsg.uploadPhotoNum" placeholder=""></el-input>张 </el-form-item>
        <el-form-item label="重量:" prop="weight">
          <el-input v-model="skuMsg.weight" placeholder=""></el-input>g </el-form-item>
        <el-form-item label="是否合成半P:" prop="isComposeHalfP" v-if="skuMsg.spuType === 'photo'">
          <el-radio-group v-model="skuMsg.isComposeHalfP">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="封面合成位置:" prop="coverPosition">
          <el-select v-model="skuMsg.coverPosition" value-key="id" placeholder="请选择" clearable>
            <el-option label="首页" value="FIRST_PAGE"></el-option>
            <el-option label="尾页" value="LAST_PAGE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面合成坐标:" prop="param"> 左：<el-input type="number" style="width:200px" v-model="skuMsg.leftParam" placeholder=""><template slot="append">mm</template>
          </el-input> 上：<el-input style="width:200px" type="number" v-model="skuMsg.topParam" placeholder=""><template slot="append">mm</template></el-input>
        </el-form-item>
        <el-form-item label="是否为0元购产品:" prop="isZeroPurchase">
          <el-radio-group v-model="skuMsg.isZeroPurchase" :disabled="$route.query.onSale == 'true' ? true : false">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="照片张数是否限制:" prop="limitQuantity">
          <el-radio-group v-model="skuMsg.limitQuantity">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否特殊效果:" prop="specialPrint">
          <el-radio-group v-model="skuMsg.specialPrint">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="基础P数：" prop="basePage">
          <span>{{ skuMsg.basePage }}</span>
        </el-form-item>
        <el-form-item label="一次增加P数：" prop="baseStep">
          <el-input v-model.number="skuMsg.baseStep" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="最大P数：" prop="maxPage">
          <el-input v-model.number="skuMsg.maxPage" placeholder=""></el-input>
          <el-tooltip class="item" effect="light" content="只能输入大于基础P数且为一次增加P数的倍数" placement="right">
            <i class="el-icon-question" style="font-size: 18px;cursor: pointer;"></i>
          </el-tooltip>
        </el-form-item>
        <div style="display: flex;">
          <el-form-item label="基础P平台价格：" prop="basePagePrice">
            <el-input v-model="skuMsg.basePagePrice" @input="changeBasePagePrice" placeholder="" :disabled="singlePrice ? haveSkuList : false"></el-input>
          </el-form-item>
          <el-form-item label="基础P积分价格：" prop="basePagePoints" v-if="$route.query.showPoint == 'true'">
            <el-input v-model="skuMsg.basePagePoints" @input="changeBasePagePoints" placeholder="" :disabled="singlePrice ? haveSkuList : false"></el-input>
          </el-form-item>
        </div>
        <div style="display: flex;">
          <el-form-item label="增加一次平台价格：" prop="baseStepPrice">
            <!-- :disabled="isdisabled || disable" -->
            <el-input v-model="skuMsg.baseStepPrice" @input="changeBaseStepPrice" placeholder="" :disabled="singlePrice"></el-input>
          </el-form-item>
          <el-form-item label="增加一次积分价格：" prop="baseStepPoints" v-if="$route.query.showPoint == 'true'">
            <!-- :disabled="isdisabled || disable" -->
            <el-input v-model="skuMsg.baseStepPoints" @input="changeBaseStepPoints" placeholder="" :disabled="singlePrice"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="基础P在线支付价格:" prop="onlineSalePrice" v-if="$route.query.showPoint != 'true'">
          <el-input v-model="skuMsg.onlineSalePrice" placeholder="" :disabled="singlePrice ? haveSkuList : false"></el-input>
        </el-form-item>
        <el-form-item label="增加一次在线支付价格：" prop="onlineBaseStepPrice" v-if="$route.query.showPoint != 'true'">
          <!-- :disabled="isdisabled || disable" -->
          <el-input v-model="skuMsg.onlineBaseStepPrice" placeholder="" :disabled="singlePrice"></el-input>
        </el-form-item>
        <!-- 新加的 -->
        <el-form-item label="基础P初创平台价格：" prop="startupsBasePagePrice" v-if="startupsSpu == 'true'">
          <el-input v-model="skuMsg.startupsBasePagePrice" placeholder="" :disabled="singlePrice ? haveSkuList : false"></el-input>
        </el-form-item>
        <el-form-item label="增加一次初创平台价格：" prop="startupsBaseStepPrice" v-if="startupsSpu == 'true'">
          <!-- :disabled="isdisabled || disable" -->
          <el-input v-model="skuMsg.startupsBaseStepPrice" placeholder="" :disabled="singlePrice"></el-input>
        </el-form-item>
        <el-form-item label="基础P推荐终端价格：" prop="terminalSalePrice">
          <el-input v-model="skuMsg.terminalSalePrice" placeholder="" :disabled="singlePrice ? haveSkuList : false"></el-input>
        </el-form-item>
        <el-form-item label="增加一次推荐终端价格：" prop="terminalStepSalePrice">
          <el-input v-model="skuMsg.terminalStepSalePrice" placeholder="" :disabled="singlePrice"></el-input>
        </el-form-item>
        <!-- <el-form-item label="最低终端价格：" prop="salePrice">
          <el-input v-model="skuMsg.salePrice" placeholder=""></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="批量数量:" prop="salePrice">
          <el-input v-model="skuMsg.salePrice" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="批量价格:" prop="salePrice">
          <el-input v-model="skuMsg.salePrice" placeholder=""></el-input>
        </el-form-item> -->
      </el-form>
      <el-tabs v-if="addSkuStep === 2" v-model="activeName">
        <el-tab-pane v-for="(item, index) in pageNameTableData" :key="item.id + item.pageName"
          :label="item.pageTypeCode === 'COVER' ? '封面设置' : item.pageTypeCode === 'TEXT' ? '内页设置' : item.pageTypeCode === 'SINGLE' ? '单页设置' : '未定义'" :name="'a' + index">
          <div class="settextbox" @click="asd">
            <p>
              <!-- 最大P数：{{item.pageTypeCode==='SINGLE'?2:item.pageTypeCode==='COVER'?skuMsg.coverPage:+item.pageNum===+skuMsg.basePage?skuMsg.maxPage:+skuMsg.maxPage - +skuMsg.coverPage}}P --> 最大P数：{{
                item.pageTypeCode !== 'TEXT' ? item.pageNum : +item.pageNum + (+skuMsg.maxPage - +skuMsg.basePage) }}P
            </p>
            <p>
              <!-- 最小P数：{{item.pageTypeCode==='SINGLE'?item.pageNum:item.pageTypeCode==='COVER'?skuMsg.coverPage:+item.pageNum===+skuMsg.basePage?skuMsg.basePage:+skuMsg.basePage - +skuMsg.coverPage}}P -->
              最小P数：{{ item.pageNum }}P
            </p>
            <p>1P=2页</p>
          </div>
          <el-form ref="form" :model="item" label-width="200px">
            <el-form-item v-for="(bar, index2) in item.barCodeList" :key="bar.id" :label="bar.barName + '出现位置：'">
              <el-select v-model="skuMsg.skuPageSettingVOList[index].barCodePositionList[index2].barCodePosition" placeholder="">
                <el-option v-for="pos in item.barPosition" :key="pos.id + pos.dictValue" :label="pos.dictValue" :value="pos.dictCode"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="不进入合成页序：">
              <el-input style="width:50px" v-model="skuMsg.skuPageSettingVOList[index].noComposePageNumStart"></el-input>到<el-input style="width:50px;margin-left:10px"
                v-model="skuMsg.skuPageSettingVOList[index].noComposePageNumEnd"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入不进入合成的页序区间，已确定不<br />进入合成的页序，将会锁定不可编辑，<br>不可调序，使用”,“隔开。</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item v-if="item.typeName !== '封面'" label="不可排序页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].noAllowSortPage"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入不可排序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="不可编辑页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].noAllowEditPage"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入不可编辑页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="封面通用文件页序：" v-if="!skuMsg.specialPrint && item.pageTypeCode === 'COVER'">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].generalFilePage"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入封面通用文件页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="pdf页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].pdfPage"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入pdf页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="扉页通用烫金PDF页序：" v-if="item.pageTypeCode === 'TEXT'">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].titlePagePdfPage"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入扉页通用烫金PDF页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="只读页序：">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].readonlyPage"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入只读页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="半页不可编辑页序：">
              <i class="el-icon-circle-plus" @click="addPageVOS(index)" style="font-size: 18px;"></i>
              <div v-for="(a, b) in skuMsg.skuPageSettingVOList[index].skuPageSettingHalfPageVOS" :key="b" style="display:flex;margin-top: 10px;">
                <el-select v-model="a.sort" placeholder="请选择" clearable>
                  <el-option label="正序" :value="0"></el-option>
                  <el-option label="倒序" :value="1"></el-option>
                </el-select>
                <el-input v-model="a.noAllowEditPage" placeholder="请输入页序" style="margin-left:20px"></el-input>
                <el-select v-model="a.position" placeholder="请选择" clearable>
                  <el-option label="左" :value="0"></el-option>
                  <el-option label="右" :value="1"></el-option>
                </el-select>
              </div>
            </el-form-item>
            <!-- 以下新加 -->
            <el-form-item label="是否拆分pdf:">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].splitPdf" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"></el-switch>
            </el-form-item>
            <el-form-item label="银卡拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageYk"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageYkDesc"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="透片拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTp"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTpDesc"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="磨砂透片拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageMstp"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageMstpDesc"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="UV/烫哑金拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTjuv"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTjuvDesc"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="UV/烫亮金拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTljuv"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTljuvDesc"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="UV/烫镭射银拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTlsyuv"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTlsyuvDesc"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="UV/烫镭射金拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTlsjuv"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageTlsjuvDesc"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="MGI镭射银卡UV拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageMGIYuv"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageMGIYuvDesc"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="牛皮纸拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageNpz"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageNpzDesc"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="其他拆分指定页：" v-if="skuMsg.skuPageSettingVOList[index].splitPdf == 1">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageQt"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;margin-right: 30px;" class="el-icon-question"></i>
              </el-tooltip>
              <el-input v-model="skuMsg.skuPageSettingVOList[index].splitPageQtDesc"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入倒序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="是否镜像:">
              <el-radio-group v-model="skuMsg.skuPageSettingVOList[index].flip">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">水平翻转</el-radio>
                <el-radio :label="2">垂直翻转</el-radio>
                <el-radio :label="3">同时翻转</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="全部页:" v-if="skuMsg.skuPageSettingVOList[index].flip">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].flipAllPage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                @change="switchChange($event, index, 1)"></el-switch>
            </el-form-item>
            <el-form-item label="偶数页:" v-if="skuMsg.skuPageSettingVOList[index].flip">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].flipEvenPage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                @change="switchChange($event, index, 2)"></el-switch>
            </el-form-item>
            <el-form-item label="奇数页:" v-if="skuMsg.skuPageSettingVOList[index].flip">
              <el-switch v-model="skuMsg.skuPageSettingVOList[index].flipOddPage" active-color="#1473E6" inactive-color="#8c8c8c" :active-value="1" :inactive-value="0"
                @change="switchChange($event, index, 3)"></el-switch>
            </el-form-item>
            <el-form-item label="指定页：" v-if="skuMsg.skuPageSettingVOList[index].flip">
              <el-input v-model="skuMsg.skuPageSettingVOList[index].flipSpecifyPage" @change="switchChange($event, index, 4)"></el-input>
              <el-tooltip class="item" effect="light" placement="right-end">
                <div slot="content">输入正序页序，使用“,”隔开</div>
                <i style="font-size: 18px;" class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button v-show="addSkuStep === 1" type="primary" @click="addSkuNextStep()" v-preventReClick>下一步</el-button>
        <el-button v-show="addSkuStep === 2" type="primary" @click="addSkuStep = 1" v-preventReClick>上一步</el-button>
        <el-button v-show="addSkuStep === 2" type="primary" @click="confirmAddSku" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 统一样品价格 -->
    <el-dialog :close-on-click-modal="false" title="设置样品价格" :visible.sync="samplePriceDialog" width="30%">
      <el-form ref="samplePriceForm" :model="samplePriceForm" :rules="samplePriceRules" label-width="150px">
        <el-form-item label="样品价格:" prop="samplePrice">
          <el-input v-model="samplePriceForm.samplePrice"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="samplePriceDialog = false">取 消</el-button>
        <el-button type="primary" @click="setSamplePrice" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 统一样品积分价格 -->
    <el-dialog :close-on-click-modal="false" title="设置样品积分价格" :visible.sync="samplePointsDialog" width="30%">
      <el-form ref="samplePointsForm" :model="samplePointsForm" :rules="samplePointsRules" label-width="150px">
        <el-form-item label="样品积分价格:" prop="samplePoints">
          <el-input v-model="samplePointsForm.samplePoints"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="samplePointsDialog = false">取 消</el-button>
        <el-button type="primary" @click="setSamplePoints" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="设置样品价格" :visible.sync="onlineSamplePriceDialog" width="30%">
      <el-form ref="onlineSamplePriceForm" :model="onlineSamplePriceForm" :rules="onlineSamplePriceRules" label-width="150px">
        <el-form-item label="样品价格:" prop="onlineSamplePrice">
          <el-input v-model="onlineSamplePriceForm.onlineSamplePrice"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onlineSamplePriceDialog = false">取 消</el-button>
        <el-button type="primary" @click="setonlineSamplePrice" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 初创平台样品价格 -->
    <el-dialog :close-on-click-modal="false" title="设置初创平台样品价格" :visible.sync="startupsSamplePriceDialog" width="30%">
      <el-form ref="onlineSamplePriceForm" :model="onlineSamplePriceForm" :rules="startupsSamplePriceRules" label-width="150px">
        <el-form-item label="样品价格:" prop="startupsSamplePrice">
          <el-input v-model="onlineSamplePriceForm.startupsSamplePrice"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="startupsSamplePriceDialog = false">取 消</el-button>
        <el-button type="primary" @click="setStartupsSamplePrice" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑样品主题 -->
    <el-dialog :close-on-click-modal="false" title="样品设置" :visible.sync="sampleThemeDialog" :before-close="close" width="715px">
      <el-form ref="form" :model="sampleThemeForm" label-width="80px">
        <el-form-item label="样品主题:">
          <el-select value-key="id" v-model="themeItem" placeholder="请选择">
            <el-option v-for="item in themeList" :key="item.id" :label="item.themeName" :value="item">
            </el-option>
          </el-select>
          <el-button type="primary" style="margin-left:20px" @click="addTheme" round>添加</el-button>
        </el-form-item>
        <el-form-item label="">
          <el-table border :data="themeTabelData" style="width: 100%">
            <!-- <el-table-column prop="themeName" label="样品编码">
              <template slot-scope="scope">
                <el-input v-model="scope.row.sampleBarCode" placeholder="请输入内容"></el-input>
              </template>
            </el-table-column> -->
            <el-table-column prop="themeName" label="主题">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span @click="deleteTheme(scope)" class="color-blue">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="sampleThemeDialog = false">取 消</el-button> -->
        <el-button type="primary" @click="close()">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 管理Sku -->
    <el-dialog :close-on-click-modal="false" title="管理SKU" border :visible.sync="setSkuDialog" width="1220px">
      <el-table :data="skuTableData" style="width: 100%">
        <el-table-column prop="skuName" label="SKU名称" width="100px"></el-table-column>
        <el-table-column prop="skuFrontName" label="SKU前端显示名称" width="100px"></el-table-column>
        <el-table-column prop="basePage" label="基础P数" width="80px"></el-table-column>
        <el-table-column prop="maxPage" label="最大P数" width="80px"></el-table-column>
        <el-table-column prop="baseStep" label="一次增加P数" width="100px"></el-table-column>
        <el-table-column prop="basePagePrice" label="基础P平台价格" width="80px"></el-table-column>
        <el-table-column prop="baseStepPrice" label="增加一次平台价格" width="100px"></el-table-column>
        <el-table-column prop="onlineBaseStepPrice" label="增加一次在线支付平台价格" width="120px"></el-table-column>
        <!-- 新加的 -->
        <el-table-column prop="startupsBasePagePrice" label="基础P初创平台价格" min-width="130px" v-if="startupsSpu == 'true'"></el-table-column>
        <el-table-column prop="startupsBaseStepPrice" label="增加一次初创平台价价格" min-width="130px" v-if="startupsSpu == 'true'"></el-table-column>
        <el-table-column prop="terminalSalePrice" label="基础P推荐终端价格" width="110px"></el-table-column>
        <el-table-column prop="terminalStepSalePrice" label="增加一次推荐终端价格" width="110px"></el-table-column>
        <el-table-column label="尺寸组" width="100px">
          <template slot-scope="scope">
            <span class="color-blue" @click="checkSizeGroup(scope.row)">查看尺寸组</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100px">
          <template slot-scope="scope">
            <span @click="editSku(scope.row)" class="color-blue">编辑</span><br>
            <span @click="deleteSku(scope.row.index)" class="color-blue">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setSkuDialog = false">取 消</el-button>
        <el-button type="primary" @click="setSkuDialog = false" v-preventReClick>确 定</el-button>
      </span>
      <!-- 查看尺寸组 -->
      <el-dialog :close-on-click-modal="false" width="900px" title="尺寸组" :visible.sync="innerVisible" append-to-body>
        <el-table :data="checkSizeGroupTableData" border>
          <el-table-column type="expand">
            <template v-slot='scope'>
              <div style="width:100%;height:100%;background:red">
                <el-table :data="scope.row.sizeList" border>
                  <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                  <el-table-column label="页面类型" prop="typeName">
                    <template slot-scope="scope"> {{ scope.row.pageTypeCode === 'COVER' ? '封面' : scope.row.pageTypeCode === 'TEXT' ? '内页' : scope.row.pageTypeCode === 'SINGLE' ? '单页' : '' }}
                    </template>
                  </el-table-column>
                  <el-table-column label="页面名称" prop="pageName"></el-table-column>
                  <el-table-column label="宽高">
                    <template slot-scope="scope"> 宽度：{{ scope.row.sizeWidth }}mm<br> 高度：{{ scope.row.sizeHeight }}mm </template>
                  </el-table-column>
                  <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                  <el-table-column label="出血" width="220px">
                    <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{ scope.row.bleed.bleedRight
                    }}mm <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
                  </el-table-column>
                  <el-table-column label="码" prop="barCodeId">
                    <template slot-scope="scope">
                      <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="尺寸组名称" min-width="100px" prop="groupName"></el-table-column>
          <el-table-column label="尺寸组类" prop="groupCategoryId" min-width="100px"></el-table-column>
          <el-table-column label="页面名称" prop="pageName" min-width="100px">
            <template slot-scope="scope"> {{ scope.row.pageName.substring(0, scope.row.pageName.length - 1) }} </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="确认提示" border :visible.sync="hintDialog" width="500px"> 添加sku前请统一关联尺寸组 <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="hintDialog = false" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { storeTypeGetStoreTypeList, getPointRules } from '@/api/crm'
import { dictGet, barCodePosition, groupListPageing, pageNameListById, skuGroupAddDetail, skuUsable, sampleListNoPaging, composeGroupDetail, groupCategoryList, skuGroupDetail } from '@/api/pms'
export default {
  name: 'CreateNewSKu2',
  components: {
    VPagination
  },
  data () {
    var checkBaseStep = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入步长'))
      } else {
        if (+value === 0) {
          callback(new Error('步长最小为1'))
        }
        callback()
      }
    }
    var checkPrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入样品价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('样品价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var checkPoints = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入样品积分价格'))
      } else if (!this.$reg.checkInteger.reg.test(value)) {
        callback(new Error('样品积分价格' + this.$reg.checkInteger.message))
      } else {
        callback()
      }
    }
    var checkBasePagePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入基础P价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('基础P价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var checkBasePagePoints = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入基础P积分价格'))
      } else if (!this.$reg.checkInteger.reg.test(value)) {
        callback(new Error('基础P积分价格' + this.$reg.checkInteger.message))
      } else {
        callback()
      }
    }
    var terminalSalePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入基础P推荐终端价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('基础P推荐终端价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var checkBaseStepPrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入增加一次价格'))
      } else if (!this.$reg.elsePrice.reg.test(value)) {
        callback(new Error('' + this.$reg.elsePrice.message))
      } else {
        callback()
      }
    }
    var checkBaseStepPoints = (rule, value, callback) => {
      console.log('增加一次积分价格', this.skuMsg.baseStepPoints)

      if (value === '') {
        callback(new Error('请输入增加一次积分价格'))
      } else if (!this.$reg.checkInteger.reg.test(value)) {
        callback(new Error('' + this.$reg.checkInteger.message))
      } else {
        callback()
      }
    }
    var terminalStepSalePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入增加一次推荐终端价格：'))
      } else if (!this.$reg.elsePrice.reg.test(value)) {
        callback(new Error('' + this.$reg.elsePrice.message))
      } else {
        callback()
      }
    }
    var onlineBaseStepPrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入在线支付增加一次价格'))
      } else if (!this.$reg.elsePrice.reg.test(value)) {
        callback(new Error('' + this.$reg.elsePrice.message))
      } else {
        callback()
      }
    }
    var startupsBaseStepPrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入增加一次初创平台价格'))
      } else if (!this.$reg.elsePrice.reg.test(value)) {
        callback(new Error('' + this.$reg.elsePrice.message))
      } else {
        callback()
      }
    }
    var checkSalePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入最低终端价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('最低终端价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var checkOnlineSalePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入在线支付价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('在线支付价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var checkStartupsSalePrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入基础P初创平台价格'))
      } else if (!this.$reg.price.reg.test(value)) {
        callback(new Error('基础P初创平台价格' + this.$reg.price.message))
      } else {
        callback()
      }
    }
    var skuName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入sku名称'))
      } else if (this.$reg.skuName.reg.test(value)) {
        callback(new Error(this.$reg.skuName.message))
      } else {
        callback()
      }
    }
    var skuFrontName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入sku前端显示名称'))
      } else if (this.$reg.skuName.reg.test(value)) {
        callback(new Error(this.$reg.skuName.message))
      } else {
        callback()
      }
    }
    return {
      singlePrice: false,
      startupsSpu: false, // 是否初创产品
      haveSkuList: false,
      isdisabled: false,
      hintDialog: false,
      pageNumLock: false,
      samplePriceRules: {
        samplePrice: [
          { required: true, validator: checkPrice, trigger: 'blur' }
        ]
      },
      samplePointsRules: {
        samplePoints: [
          { required: true, validator: checkPoints, trigger: 'blur' }
        ]
      },
      onlineSamplePriceRules: {
        onlineSamplePrice: [
          { required: true, validator: checkPrice, trigger: 'blur' }
        ]
      },
      startupsSamplePriceRules: {
        startupsSamplePrice: [
          { required: true, validator: checkPrice, trigger: 'blur' }
        ]
      },
      step1Rules: {
        uploadPhotoNum: [{ required: true, message: '请填写用户应上传照片张数', trigger: 'change' }],
        weight: [{ required: true, message: '请填写重量', trigger: 'change' }],
        skuName: [
          { required: true, validator: skuName, trigger: 'blur' }
        ],
        skuFrontName: [
          { required: true, validator: skuFrontName, trigger: 'blur' }
        ],
        basePage: [
          { required: true, message: '请选择尺寸组', trigger: 'change' }
        ],
        baseStep: [
          { required: true, validator: checkBaseStep, trigger: 'blur' },
          { type: 'number', min: 0, message: '请输入大于等于0的值' }
        ],
        maxPage: [
          { required: true, message: '请输入最大P数', trigger: 'blur' },
          { type: 'number', min: 0, message: '请输入大于等于0的值' }
        ],
        basePagePrice: [
          { required: true, validator: checkBasePagePrice, trigger: 'blur' }
        ],
        basePagePoints: [
          { required: true, validator: checkBasePagePoints, trigger: 'blur' }
        ],
        baseStepPrice: [
          { required: false, validator: checkBaseStepPrice, trigger: 'blur' }
        ],
        baseStepPoints: [
          { required: false, validator: checkBaseStepPoints, trigger: 'blur' }
        ],
        terminalSalePrice: [
          { required: true, validator: terminalSalePrice, trigger: 'blur' }
        ],
        terminalStepSalePrice: [
          { required: true, validator: terminalStepSalePrice, trigger: 'blur' }
        ],
        onlineBaseStepPrice: [
          { required: true, validator: onlineBaseStepPrice, trigger: 'blur' }
        ],
        startupsBaseStepPrice: [
          { required: true, validator: startupsBaseStepPrice, trigger: 'blur' }
        ],
        // salePrice: [
        //   { required: true, validator: checkSalePrice, trigger: 'blur' }
        // ],
        onlineSalePrice: [
          { required: true, validator: checkOnlineSalePrice, trigger: 'blur' }
        ],
        startupsBasePagePrice: [
          { required: true, validator: checkStartupsSalePrice, trigger: 'blur' }
        ]
      },
      value: '',
      activeName: 'a0',
      coverSet: {},
      addSkuStep: 1,
      tableData: [],
      sampleThemeForm: {
        themeName: ''
      },
      samplePriceForm: {
        samplePrice: '',
        singleSamplePrice: ''
      },
      samplePointsForm: {
        samplePoints: '',
        singleSamplePoints: ''
      },
      onlineSamplePriceForm: {
        onlineSamplePrice: '',
        startupsSamplePrice: '',
        singleonlineSamplePrice: ''
      },
      checkSizeGroupTableData: [],
      skuTableData: [],
      themeItem: null,
      themeTabelData: [],
      innerVisible: false,
      setSkuDialog: false,
      sampleThemeDialog: false,
      samplePriceDialog: false,
      samplePointsDialog: false,
      onlineSamplePriceDialog: false,
      startupsSamplePriceDialog: false,
      addSkuDialog: false,
      skuMsgName: '',
      skuMsg: {
        weight: 0,
        uploadPhotoNum: null,
        isComposeHalfP: false,
        isZeroPurchase: false,
        limitQuantity: true,
        specialPrint: 0,
        coverPosition: '',
        leftParam: '',
        topParam: '',
        isHavePromoCode: false,
        skuPrefix: '',
        basePage: 0,
        basePagePrice: 0,
        basePagePoints: 0,
        terminalSalePrice: 0,
        terminalStepSalePrice: 0,
        baseStep: 1,
        baseStepPrice: 0,
        baseStepPoints: 0,
        onlineBaseStepPrice: 0,
        composeSizeGroupId: 0,
        maxPage: 0,
        skuName: '',
        skuFrontName: '',
        coverPage: '',
        // salePrice: '',
        onlineSalePrice: '',
        startupsBasePagePrice: '', // 初创平台价格
        startupsBaseStepPrice: 0, // 初创价格步长
        skuPageSettingVOList: [
          {
            noAllowEditPage: '',
            noAllowSortPage: '',
            generalFilePage: '',
            titlePagePdfPage: '',
            pdfPage: '',
            readonlyPage: '',
            skuPageSettingHalfPageVOS: [
              {
                sort: null,
                noAllowEditPage: '',
                position: null
              }
            ],
            noComposePageNumEnd: 0,
            noComposePageNumStart: 0,
            skuPageType: '',
            splitPdf: 0,
            splitPageYk: '',
            splitPageYkDesc: '',
            splitPageTp: '',
            splitPageTpDesc: '',
            splitPageMstp: '',
            splitPageMstpDesc: '',
            splitPageTjuv: '',
            splitPageTjuvDesc: '',
            splitPageTljuv: '',
            splitPageTljuvDesc: '',
            splitPageTlsyuv: '',
            splitPageTlsyuvDesc: '',
            splitPageTlsjuv: '',
            splitPageTlsjuvDesc: '',
            splitPageMGIYuv: '',
            splitPageMGIYuvDesc: '',
            splitPageNpz: '',
            splitPageNpzDesc: '',
            splitPageQt: '',
            splitPageQtDesc: '',
            flip: 0,
            flipAllPage: 0,
            flipEvenPage: 0,
            flipOddPage: 0,
            flipSpecifyPage: ''
          }
        ]
      },
      isComposeHalfP: false,
      addSkuGroupStepTwoVo: {
        skuGroups: [
        ],
        spuId: JSON.parse(this.$route.query.detail)[0].spuId
      },
      sizeGroupTypeList: [],
      searchComposeSizeGroupVO: {
        groupCategoryId: '',
        groupName: '',
        userId: this.$store.state.user.userId
      },
      sizeGroupList: [],
      sizeDialog: false,
      attrNameList: [],
      skuTitle: '统一添加',
      sampleTheme: [],
      attrList: {
        type: '',
        showAttr: [],
        hideAttr: []
      },
      rules: {},
      // sku组属性
      skuList: [],
      platformType: [],
      tableColumns: [],
      themeList: [],
      storeTypeName: {},
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      type: '',
      themeType: '',
      nowSkuGroupIndex: '',
      relationSizeGroupList: [],
      pageNameTableData: [],
      allThemeTableData: [],
      barPosition: {
        cover: {
          has: [],
          none: []
        },
        page: {
          has: [],
          none: []
        }
      },
      isEditSku: false,
      disable: false,
      basePagePointsEdited: false,
      baseStepPointsEdited: false,
      pointExchangeRote: 0
    }
  },
  created () {
    console.log('this.$route.query', this.$route.query)
    this.handleMsg()
    this.getSizeGroupTypeList()
    this.getSampleList()
    this.getBarPositionList()
    this.getSkuGroupMsg()
    if (this.$route.query.showPoint == 'true') {
      this.getUserPointExchangeRote()
    }
  },
  methods: {
    getUserPointExchangeRote () {
      getPointRules('WD').then(res => {
        if (res.data.success) {
          this.pointExchangeRote = res.data.data.exchangeRate
        }
      })
    },
    changeBasePagePrice () {
      console.log('changeBasePagePrice')
      if (this.basePagePointsEdited) {
        this.$forceUpdate()
        return
      }
      if (!this.pointExchangeRote) {
        this.$forceUpdate()
        return
      }
      this.skuMsg.basePagePoints = Math.ceil(this.skuMsg.basePagePrice * this.pointExchangeRote) + ''
      this.$forceUpdate()
    },
    changeBasePagePoints () {
      console.log('changeBasePagePoints', this.skuMsg.basePagePoints)
      this.basePagePointsEdited = true
      this.$forceUpdate()
    },
    changeBaseStepPrice () {
      console.log('changeBasePagePrice')
      if (this.baseStepPointsEdited) {
        this.$forceUpdate()
        return
      }
      if (!this.pointExchangeRote) {
        this.$forceUpdate()
        return
      }
      this.skuMsg.baseStepPoints = Math.ceil(this.skuMsg.baseStepPrice * this.pointExchangeRote) + ''
      this.$forceUpdate()
    },
    changeBaseStepPoints () {
      console.log('changeBaseStepPoints')
      this.baseStepPointsEdited = true
      this.$forceUpdate()
    },

    changeItemSamplePrice (item) {
      console.log('changeBasePagePrice')
      if (item.samplePointsEdited) {
        this.$forceUpdate()
        return
      }
      if (!this.pointExchangeRote) {
        this.$forceUpdate()
        return
      }
      item.samplePoints = Math.ceil(item.samplePrice * this.pointExchangeRote) + ''
      this.$forceUpdate()
    },

    changeItemSamplePoints (item) {
      // console.log('changeBaseStepPoints222', item.samplePoints, this.addSkuGroupStepTwoVo.skuGroups[0].samplePoints)
      item.samplePointsEdited = true
      this.$set(item, 'samplePointsEdited', true)
      this.$forceUpdate()
    },

    addPageVOS (index) {
      this.skuMsg.skuPageSettingVOList[index].skuPageSettingHalfPageVOS.push(
        {
          sort: null,
          noAllowEditPage: '',
          position: null
        })
    },
    switchChange (value, index, type) {
      if (type == 1 && value == 1) {
        this.skuMsg.skuPageSettingVOList[index].flipEvenPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipOddPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipSpecifyPage = ''
      } else if (type == 2 && value == 1) {
        this.skuMsg.skuPageSettingVOList[index].flipAllPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipOddPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipSpecifyPage = ''
      } else if (type == 3 && value == 1) {
        this.skuMsg.skuPageSettingVOList[index].flipAllPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipEvenPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipSpecifyPage = ''
      } else if (type == 4 && value) {
        this.skuMsg.skuPageSettingVOList[index].flipAllPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipEvenPage = 0
        this.skuMsg.skuPageSettingVOList[index].flipOddPage = 0
      }
    },
    // 获取sku组信息
    async getSkuGroupMsg () {
      console.log(this.$route.query)
      let id = JSON.parse(this.$route.query.detail)[0].id
      console.log(id)
      await skuGroupDetail(id).then(res => {
        if (res.data.success) {
          console.log(res.data, 'res.data')
          this.singlePrice = res.data.data.singlePrice
          this.skuMsg.isHavePromoCode = res.data.data.isHavePromoCode
          this.startupsSpu = this.$route.query.startupsSpu || false
        }
      })
    },

    close (done) {
      if (!done) {
        this.sampleThemeDialog = false
      } else {
        done()
      }
    },
    changePage (val) {
      this.queryInfo = val
      this.getSizeGroupList()
    },
    beforeClose () {
      this.activeName = 'a0'
      this.addSkuStep = 1
      this.skuMsgName = ''
      this.pageNameTableData = []
      this.basePagePointsEdited = false
      this.baseStepPointsEdited = false
      // this.skuMsg = {}
      // this.$refs.formaaa.clearValidate()
    },
    // 获取条码位置
    getBarPositionList () {
      barCodePosition().then(res => {
        if (res.data.success) {
          this.barPosition.page.has = res.data.data
          this.barPosition.page.none = res.data.data.filter(item => {
            return item.dictValue.indexOf('白页') === -1
          })
          this.barPosition.cover.has = res.data.data.filter(item => {
            return item.dictValue.indexOf('步长') === -1
          })
          this.barPosition.cover.none = this.barPosition.cover.has.filter(item => {
            return item.dictValue.indexOf('白页') === -1
          })
        }
      })
    },
    // 添加sku下一步
    addSkuNextStep () {
      this.$refs.formaaa.validate((valid) => {
        if (valid) {
          if (this.skuMsg.isComposeHalfP > this.skuMsg.basePage) {
            this.$message.error('用户应上传照片张数应小于或等于基础P数量')
            return
          }
          let hasPage = this.pageNameTableData.some(page => {
            return page.pageTypeCode === 'TEXT'
          })
          if (!hasPage && this.skuMsg.basePage !== this.skuMsg.maxPage) {
            this.$message.error('尺寸组没有内页，基础P应等于最大P')
          } else if (this.pageNumLock) {
            this.$message.error('页面数量只能输入大于等于1的值')
          } else if ((this.skuMsg.maxPage - this.skuMsg.basePage) % this.skuMsg.baseStep !== 0) {
            this.$message.error('最大P数和步长不匹配')
          } else if (this.skuMsg.maxPage < this.skuMsg.basePage) {
            this.$message.error('最大P数不得小于基础P')
          } else {
            skuUsable({ skuName: this.skuMsg.skuName, isUpdate: false, isFront: false }).then(res => {
              if (res.data.success) {
                skuUsable({ skuName: this.skuMsg.skuFrontName, isUpdate: false, isFront: true }).then(res => {
                  if (res.data.success) {
                    this.addSkuStep = 2
                  }
                })
              }
            })
          }
        }
      })
    },
    asd () {
    },
    // 删除sku
    deleteSku (index) {
      this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].skus.splice(index, 1)
      this.$forceUpdate()
    },
    // 编辑sku
    editSku (row) {
      let b = false
      // console.log(typeof this.skuMsg.isHavePromoCode)
      // console.log(this.skuMsg.isHavePromoCode)
      let a = typeof this.skuMsg.isHavePromoCode
      if (a === 'boolean') {
        if (this.skuMsg.isHavePromoCode) {
          b = this.skuMsg.isHavePromoCode
          this.disable = true
        }
      } else {
        if (this.skuMsg.isHavePromoCode === 'true') {
          console.log(this.skuMsg.isHavePromoCode)
          b = true
          this.disable = true
        }
      }

      this.isEditSku = true
      this.skuMsg = row
      this.skuMsgName = row.skuMsgName
      this.pageNameTableData = row.pageNameTableData
      console.log(this.skuMsg)
      this.addSkuDialog = true
    },
    // 查看尺寸组
    checkSizeGroup (row) {
      composeGroupDetail(row.composeSizeGroupId).then(res => {
        if (res.data.success) {
          this.checkSizeGroupTableData = [res.data.data]
        }
      })
      this.innerVisible = true
    },
    // 管理sku
    setSku (index) {
      this.nowSkuGroupIndex = index
      this.skuTableData = this.addSkuGroupStepTwoVo.skuGroups[index].skus
      this.setSkuDialog = true
    },
    // 创建sku组
    onSubmit () {
      let skuLock = false
      let priceLock = false
      let onlineSamplePriceLock = false
      let dataLock = false
      let onlineSamplePricedataLock = false
      this.addSkuGroupStepTwoVo.skuGroups.forEach(skuG => {
        if (skuG.skus.length === 0) {
          skuLock = true
        }
        if (skuG.samplePrice === '') {
          priceLock = true
        } else if (!this.$reg.price.reg.test(skuG.samplePrice)) {
          dataLock = true
        }
        if (skuG.onlineSamplePrice === '') {
          onlineSamplePriceLock = true
        } else if (!this.$reg.price.reg.test(skuG.onlineSamplePrice)) {
          onlineSamplePricedataLock = true
        }
        // 初创平台价格
        if (skuG.startupsSamplePrice === '' && this.startupsSpu == 'true') {
          onlineSamplePriceLock = true
        } else if (!this.$reg.price.reg.test(skuG.startupsSamplePrice) && this.startupsSpu == 'true') {
          onlineSamplePricedataLock = true
        }
      })
      if (skuLock) {
        this.$message.error('有未添加sku的sku组')
        return
      } else if (priceLock) {
        this.$message.error('有未设置的样品价格')
        return
      } else if (dataLock) {
        this.$message.error('样品价格' + this.$reg.price.message)
        return
      } else if (onlineSamplePriceLock) {
        this.$message.error('有未设置的样品价格')
        return
      } else if (onlineSamplePricedataLock) {
        this.$message.error('样品价格' + this.$reg.price.message)
        return
      }
      skuGroupAddDetail(this.addSkuGroupStepTwoVo).then(res => {
        if (res.data.success) {
          this.$message.success('创建成功')
          this.$router.push({ path: '/correlationsku', query: { id: this.addSkuGroupStepTwoVo.spuId, isVip: this.$route.query.isVip } })
        }
      })
    },
    // 删除样品
    deleteTheme (scope) {
      if (this.themeType === 'all') {
        this.addSkuGroupStepTwoVo.skuGroups.forEach(item => {
          item.sampleThemeIdSet.splice(item.sampleThemeIdSet.indexOf(this.themeItem.id), 1)
        })
        this.allThemeTableData.splice(this.allThemeTableData.indexOf(this.themeItem), 1)
      } else if (this.themeType === 'single') {
        // this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeIdSet.splice(this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeIdSet.indexOf(this.themeItem.id), 1)
        // this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeList.forEach
        // this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeList.splice(this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeList.indexOf(this.themeItem.id), 1)
        this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeList.splice(scope.$index, 1)
        this.setThemeTableData()
      }
    },
    // 样品表格数据
    setThemeTableData () {
      this.themeTabelData = this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeList
      // this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeIdSet.forEach(id => {
      //   this.themeList.forEach(item => {
      //     if (item.id === id) {
      //       this.themeTabelData.push(item)
      //     }
      //   })
      // })
    },
    // 添加样品主题
    addTheme () {
      if (this.themeItem === null) {
        return
      }
      if (this.themeType === 'all') {
        // if (
        //   this.allThemeTableData.some(theme => {
        //     return theme.id === this.themeItem.id
        //   })
        // ) {
        //   return
        // }
        // this.addSkuGroupStepTwoVo.skuGroups.forEach(item => {
        //   item.sampleThemeIdSet.push(this.themeItem.id)
        //   item.sampleThemeIdSet = Array.from(new Set(item.sampleThemeIdSet))
        //   if (
        //     !item.sampleThemeList.some(theme => {
        //       return theme.id === this.themeItem.id
        //     })
        //   ) {
        //     item.sampleThemeList.push({
        //       sampleBarCode: '',
        //       sampleId: this.themeItem.id
        //     })
        //   }
        // })
        // this.allThemeTableData.push({ sampleBarCode: '', ...this.themeItem })
        // // this.allThemeTableData = Array.from(new Set(this.allThemeTableData))
        // this.themeTabelData = this.allThemeTableData
      } else if (this.themeType === 'single') {
        if (
          this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeList.some(theme => {
            return theme.id === this.themeItem.id
          })
        ) {
          return
        }
        this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeList.push({ sampleBarCode: '', sampleId: this.themeItem.id, ...this.themeItem })
        // this.themeTabelData = this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeList
        this.setThemeTableData()
        // this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeIdSet = Array.from(new Set(this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].sampleThemeIdSet))
        // this.setThemeTableData()
      }
    },
    // 获取样品主题列表
    getSampleList () {
      sampleListNoPaging().then(res => {
        if (res.data.success) {
          this.themeList = res.data.data
        }
      })
    },
    // 统一设置样品价格
    setSamplePrice () {
      this.$refs.samplePriceForm.validate((valid) => {
        if (!valid) {
          return
        }
        this.addSkuGroupStepTwoVo.skuGroups.forEach(item => {
          item.samplePrice = this.samplePriceForm.samplePrice
          if (!item.samplePointsEdited && this.pointExchangeRote) {
            item.samplePoints = Math.ceil(this.samplePriceForm.samplePrice * this.pointExchangeRote) + ''
          }
        })
        this.samplePriceDialog = false
      })
    },
    setSamplePoints () {
      this.$refs.samplePointsForm.validate((valid) => {
        if (!valid) {
          return
        }
        this.addSkuGroupStepTwoVo.skuGroups.forEach(item => {
          item.samplePoints = this.samplePointsForm.samplePoints
          item.samplePointsEdited = true
        })
        this.samplePointsDialog = false
      })
    },
    // 统一设置在线支付样品价格
    setonlineSamplePrice () {
      this.$refs.onlineSamplePriceForm.validate((valid) => {
        if (!valid) {
          return
        }
        this.addSkuGroupStepTwoVo.skuGroups.forEach(item => {
          item.onlineSamplePrice = this.onlineSamplePriceForm.onlineSamplePrice
        })
        this.onlineSamplePriceDialog = false
      })
    },
    // 统一设置初创平台样品价格
    setStartupsSamplePrice () {
      this.$refs.onlineSamplePriceForm.validate((valid) => {
        if (!valid) {
          return
        }
        this.addSkuGroupStepTwoVo.skuGroups.forEach(item => {
          item.startupsSamplePrice = this.onlineSamplePriceForm.startupsSamplePrice
        })
        this.startupsSamplePriceDialog = false
      })
    },
    // 确认添加sku
    confirmAddSku () {
      this.addSkuStep = 1
      this.addSkuDialog = false
      if (this.isEditSku) {
        this.skuMsg = {}
        return
      }
      // this.skuMsg.skuName = this.skuList[this.nowSkuGroupIndex].skuGroupName + this.skuMsg.basePage + '-' + this.skuMsg.maxPage
      let {
        skuPrefix,
        basePage,
        basePagePrice,
        basePagePoints,
        terminalSalePrice,
        terminalStepSalePrice,
        baseStep,
        baseStepPrice,
        baseStepPoints,
        onlineBaseStepPrice,
        composeSizeGroupId,
        coverPage,
        singlePage,
        maxPage,
        // salePrice,
        skuName,
        skuFrontName,
        onlineSalePrice,
        startupsBasePagePrice, // 初创价格
        startupsBaseStepPrice, // 初创平台步长
        skuPageSettingVOList,
        isComposeHalfP,
        isZeroPurchase,
        limitQuantity,
        specialPrint,
        coverPosition,
        leftParam,
        topParam,
        weight,
        uploadPhotoNum
      } = this.skuMsg
      let skuItem = {}
      if (basePagePoints) {
        skuItem.basePagePoints = basePagePoints
      }
      if (baseStepPoints) {
        skuItem.baseStepPoints = baseStepPoints
      }
      console.log('pageNameTableData', this.pageNameTableData, '-------', this.skuMsgName)
      this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].skus.push({
        pageNameTableData: this.pageNameTableData,
        skuMsgName: this.skuMsgName,
        weight,
        uploadPhotoNum,
        isComposeHalfP,
        isZeroPurchase,
        limitQuantity,
        specialPrint,
        coverPosition,
        leftParam,
        topParam,
        onlineSalePrice: this.$route.query.showPoint == 'true' ? +basePagePrice : +onlineSalePrice, // 积分产品在线支付价格等于基础P价格
        startupsBasePagePrice: +startupsBasePagePrice, // 初创平台价格
        startupsBaseStepPrice: +startupsBaseStepPrice, // 初创平台步长
        skuPrefix,
        basePage: +basePage,
        basePagePrice: +basePagePrice,
        terminalSalePrice: +terminalSalePrice,
        terminalStepSalePrice: +terminalStepSalePrice || 0,
        baseStep: +baseStep,
        // salePrice: +salePrice,
        coverPage: +coverPage,
        singlePage: +singlePage,
        baseStepPrice: +baseStepPrice || 0,
        onlineBaseStepPrice: this.$route.query.showPoint == 'true' ? +baseStepPrice || 0 : +onlineBaseStepPrice, // 积分产品在线支付价格等于基础P价格
        composeSizeGroupId: +composeSizeGroupId,
        maxPage: +maxPage,
        skuPageSettingVOList,
        skuName: skuName,
        skuFrontName: skuFrontName,
        ...skuItem
      })
    },
    // 计算基础p
    countP () {
      let num = 0
      this.pageNameTableData.forEach(item => {
        if (/[^\d]/g.test(item.pageNum) || item.pageNum <= 0) {
          this.pageNumLock = true
        } else {
          this.pageNumLock = false
        }
        num += item.isBase ? +item.pageNum : 0
        if (item.pageTypeCode === 'COVER') {
          this.skuMsg.coverPage = item.pageNum
        } else if (item.pageTypeCode === 'SINGLE') {
          this.skuMsg.singlePage = item.pageNum
        }
      })
      if (this.pageNumLock) {
        this.$message.error('数量只能输入大于等于1的值')
        return
      }
      this.skuMsg.basePage = num
      this.skuMsg.uploadPhotoNum = this.skuMsg.uploadPhotoNum ? this.skuMsg.uploadPhotoNum : num
      this.$forceUpdate()
    },
    // 添加Sku 先判定该Sku组有无选择默认尺寸组
    addSku (index) {
      //   this.isEditSku = false
      //   this.addSkuDialog = true
      //   this.nowSkuGroupIndex = index
      // this.isEditSku = false
      // this.addSkuDialog = true
      let skuTableData = this.addSkuGroupStepTwoVo.skuGroups[index].skus
      console.log('let skuTableData', skuTableData, this.skuMsg)
      if (skuTableData.length > 0) {
        this.haveSkuList = true
      } else {
        this.haveSkuList = false
      }
      // 重置列表数据
      this.skuMsg = {
        weight: 0,
        uploadPhotoNum: null,
        isComposeHalfP: false,
        isZeroPurchase: false,
        limitQuantity: true,
        specialPrint: 0,
        coverPosition: '',
        leftParam: '',
        topParam: '',
        isHavePromoCode: false,
        skuPrefix: '',
        basePage: 0,
        basePagePrice: this.singlePrice && this.haveSkuList ? skuTableData[0].basePagePrice : '',
        terminalSalePrice: this.singlePrice && this.haveSkuList ? skuTableData[0].terminalSalePrice : '',
        terminalStepSalePrice: 0,
        baseStep: 1,
        baseStepPrice: 0,
        onlineBaseStepPrice: 0,
        composeSizeGroupId: 0,
        maxPage: 0,
        skuName: '',
        skuFrontName: '',
        coverPage: '',
        // salePrice: '',
        onlineSalePrice: this.singlePrice && this.haveSkuList ? skuTableData[0].onlineSalePrice : '',
        startupsBasePagePrice: this.singlePrice && this.haveSkuList ? skuTableData[0].startupsBasePagePrice : '', // 初创平台价格
        startupsBaseStepPrice: 0, // 初创平台步长
        skuPageSettingVOList: [
          {
            noAllowEditPage: '',
            noAllowSortPage: '',
            generalFilePage: '',
            titlePagePdfPage: '',
            pdfPage: '',
            readonlyPage: '',
            skuPageSettingHalfPageVOS: [
              {
                sort: null,
                noAllowEditPage: '',
                position: null
              }
            ],
            noComposePageNumEnd: 0,
            noComposePageNumStart: 0,
            skuPageType: '',
            splitPdf: 0,
            splitPageYk: '',
            splitPageYkDesc: '',
            splitPageTp: '',
            splitPageTpDesc: '',
            splitPageMstp: '',
            splitPageMstpDesc: '',
            splitPageTjuv: '',
            splitPageTjuvDesc: '',
            splitPageTljuv: '',
            splitPageTljuvDesc: '',
            splitPageTlsyuv: '',
            splitPageTlsyuvDesc: '',
            splitPageTlsjuv: '',
            splitPageTlsjuvDesc: '',
            splitPageMGIYuv: '',
            splitPageMGIYuvDesc: '',
            splitPageNpz: '',
            splitPageNpzDesc: '',
            splitPageQt: '',
            splitPageQtDesc: '',
            flip: 0,
            flipAllPage: 0,
            flipEvenPage: 0,
            flipOddPage: 0,
            flipSpecifyPage: ''
          }
        ]
      }
      let b = false
      console.log(typeof this.skuMsg.isHavePromoCode)
      console.log(this.skuMsg)
      console.log(this.skuMsg.isHavePromoCode)
      let a = typeof this.skuMsg.isHavePromoCode
      if (a === 'boolean') {
        if (this.skuMsg.isHavePromoCode) {
          b = this.skuMsg.isHavePromoCode
          this.disable = true
        }
      } else {
        if (this.skuMsg.isHavePromoCode == 'true') {
          console.log(this.skuMsg.isHavePromoCode)
          b = true
          this.disable = true
        }
      }

      if (this.$route.query.isHavePromoCode == 'true') {
        this.isdisabled = true
        this.isHavePromoCode = true
      }
      // if (this.relationSizeGroupList[index] !== undefined) {
      this.isEditSku = false
      this.addSkuDialog = true
      this.nowSkuGroupIndex = index
      // sku组已经选择了默认尺寸组
      this.skuMsg = {
        onlineSalePrice: '',
        startupsBasePagePrice: '', // 初创平台价格
        startupsBaseStepPrice: 0, // 初创平台步长
        skuPrefix: '',
        basePage: '',
        basePagePrice: '',
        terminalSalePrice: '',
        terminalStepSalePrice: 0,
        baseStep: 1,
        // salePrice: '',
        baseStepPrice: 0,
        onlineBaseStepPrice: 0,
        coverPage: '',
        singlePage: '',
        composeSizeGroupId: this.relationSizeGroupList[index]?.id,
        maxPage: '',
        skuName: '',
        skuFrontName: '',
        isHavePromoCode: b,
        isComposeHalfP: false,
        isZeroPurchase: false,
        limitQuantity: true,
        specialPrint: 0,
        coverPosition: '',
        leftParam: '',
        topParam: ''
      }
      let list = []
      if (this.relationSizeGroupList[index] !== undefined) {
        list = JSON.parse(JSON.stringify(this.relationSizeGroupList[index].detail.sizeList))

        this.skuMsgName = JSON.parse(JSON.stringify(this.relationSizeGroupList[index].groupName))
      }
      list.forEach(item => {
        item.isBase = item.spuPageName.isBase
        item.isEditable = item.spuPageName.isEditable
        item.pageNum = 1
      })
      this.skuMsg.skuPageSettingVOList = []
      list.forEach(item => {
        let obj = {
          barCodePositionList: [],
          noAllowEditPage: '',
          noAllowSortPage: '',
          generalFilePage: '',
          titlePagePdfPage: '',
          pdfPage: '',
          readonlyPage: '',
          skuPageSettingHalfPageVOS: [
            {
              sort: null,
              noAllowEditPage: '',
              position: null
            }
          ],
          noComposePageNumEnd: '',
          noComposePageNumStart: '',
          skuPageType: item.pageTypeCode,
          splitPdf: 0,
          splitPageYk: '',
          splitPageYkDesc: '',
          splitPageTp: '',
          splitPageTpDesc: '',
          splitPageMstp: '',
          splitPageMstpDesc: '',
          splitPageTjuv: '',
          splitPageTjuvDesc: '',
          splitPageTljuv: '',
          splitPageTljuvDesc: '',
          splitPageTlsyuv: '',
          splitPageTlsyuvDesc: '',
          splitPageTlsjuv: '',
          splitPageTlsjuvDesc: '',
          splitPageMGIYuv: '',
          splitPageMGIYuvDesc: '',
          splitPageNpz: '',
          splitPageNpzDesc: '',
          splitPageQt: '',
          splitPageQtDesc: '',
          flip: 0,
          flipAllPage: 0,
          flipEvenPage: 0,
          flipOddPage: 0,
          flipSpecifyPage: ''
        }
        item.barCodeList.forEach(bar => {
          obj.barCodePositionList.push({
            barCodeId: bar.id,
            barCodePosition: ''
          })
        })
        this.skuMsg.skuPageSettingVOList.push(obj)
        if (item.pageTypeCode === 'COVER') {
          if (this.$route.query.hasWhitePage === 'true') {
            item.barPosition = this.barPosition.cover.has
          } else {
            item.barPosition = this.barPosition.cover.none
          }
        } else {
          if (this.$route.query.hasWhitePage === 'true') {
            item.barPosition = this.barPosition.page.has
          } else {
            item.barPosition = this.barPosition.page.none
          }
        }
      })
      this.$nextTick(_ => {
        this.skuMsg = JSON.parse(JSON.stringify(this.skuMsg))
        this.pageNameTableData = JSON.parse(JSON.stringify(list))
        this.countP()
        this.$forceUpdate()
      })
      // } else {
      //  this.hintDialog = true
      // 原本就注释了
      // this.$message.error('未绑定尺寸组，请先绑定')
      // this.skuMsg = {
      //   onlineSalePrice: '',
      //   skuPrefix: '',
      //   basePage: '',
      //   basePagePrice: '',
      //   terminalSalePrice: '',
      //   terminalStepSalePrice: '',
      //   baseStep: 1,
      //   baseStepPrice: '',
      //   onlineBaseStepPrice: '',
      //   coverPage: '',
      //   singlePage: '',
      //   // salePrice: '',
      //   composeSizeGroupId: '',
      //   maxPage: '',
      //   skuName: '',
      //   skuFrontName: '',
      //   skuPageSettingVOList: []
      // }
      // this.pageNameTableData = []
      // this.skuMsgName = ''
      // }
    },
    // 关联
    relation (row) {
      if (this.type === 'sku') {
        this.skuMsg.composeSizeGroupId = row.id
        this.skuMsgName = row.groupName
        let list = JSON.parse(JSON.stringify(row.detail.sizeList))
        list.forEach(item => {
          item.isBase = item.spuPageName.isBase
          item.isEditable = item.spuPageName.isEditable
          item.pageNum = 1
        })
        this.skuMsg.skuPageSettingVOList = []
        list.forEach(item => {
          let obj = {
            barCodePositionList: [],
            noAllowEditPage: '',
            noAllowSortPage: '',
            generalFilePage: '',
            titlePagePdfPage: '',
            pdfPage: '',
            readonlyPage: '',
            skuPageSettingHalfPageVOS: [
              {
                sort: null,
                noAllowEditPage: '',
                position: null
              }
            ],
            noComposePageNumEnd: '',
            noComposePageNumStart: '',
            skuPageType: item.pageTypeCode,
            splitPdf: 0,
            splitPageYk: '',
            splitPageYkDesc: '',
            splitPageTp: '',
            splitPageTpDesc: '',
            splitPageMstp: '',
            splitPageMstpDesc: '',
            splitPageTjuv: '',
            splitPageTjuvDesc: '',
            splitPageTljuv: '',
            splitPageTljuvDesc: '',
            splitPageTlsyuv: '',
            splitPageTlsyuvDesc: '',
            splitPageTlsjuv: '',
            splitPageTlsjuvDesc: '',
            splitPageMGIYuv: '',
            splitPageMGIYuvDesc: '',
            splitPageNpz: '',
            splitPageNpzDesc: '',
            splitPageQt: '',
            splitPageQtDesc: '',
            flip: 0,
            flipAllPage: 0,
            flipEvenPage: 0,
            flipOddPage: 0,
            flipSpecifyPage: ''
          }
          item.barCodeList.forEach(bar => {
            obj.barCodePositionList.push({
              barCodeId: bar.id,
              barCodePosition: ''
            })
          })
          this.skuMsg.skuPageSettingVOList.push(obj)
          if (item.pageTypeCode === 'COVER') {
            if (this.$route.query.hasWhitePage === 'true') {
              item.barPosition = this.barPosition.cover.has
            } else {
              item.barPosition = this.barPosition.cover.none
            }
          } else {
            if (this.$route.query.hasWhitePage === 'true') {
              item.barPosition = this.barPosition.page.has
            } else {
              item.barPosition = this.barPosition.page.none
            }
          }
        })
        this.$nextTick(_ => {
          this.skuMsg = JSON.parse(JSON.stringify(this.skuMsg))
          this.pageNameTableData = JSON.parse(JSON.stringify(list))
          this.countP()
          this.$forceUpdate()
          this.sizeDialog = false
        })
      } else if (this.type === 'skuGroup') {
        // 如果有关联的就清空已添加的sku
        if (this.relationSizeGroupList[this.nowSkuGroupIndex] !== undefined) {
          this.addSkuGroupStepTwoVo.skuGroups[this.nowSkuGroupIndex].skus = []
        }

        // 添加到该sku组默认尺寸组中
        this.relationSizeGroupList[this.nowSkuGroupIndex] = row
        this.$message.success('绑定成功')
        this.sizeDialog = false
      }
    },
    // 选择关联尺寸组
    choiceSizeGroup (type) {
      this.type = type
      this.getSizeGroupList()
      this.sizeDialog = true
    },
    // 获取尺寸组类
    getSizeGroupTypeList () {
      groupCategoryList().then(res => {
        if (res.data.success) {
          this.sizeGroupTypeList = res.data.data
        }
      })
    },
    // 获取尺寸组信息
    getSizeGroupList () {
      groupListPageing({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, data: this.searchComposeSizeGroupVO }).then(res => {
        if (res.data.success) {
          this.queryInfo.total = res.data.data.total
          let list = res.data.data.records
          let num = 0
          if (res.data.data.records.length === 0) {
            this.sizeGroupList = list
          }
          // this.tableData = res.data.data.records
          res.data.data.records.forEach(item => {
            composeGroupDetail(item.id).then(res2 => {
              item.detail = res2.data.data
              num++
              if (num >= list.length) {
                this.sizeGroupList = list
              }
            })
          })
        }
      })
    },
    // 处理第一步带过来的数据
    handleMsg () {
      this.attrNameList = JSON.parse(this.$route.query.dict)
      let detail = JSON.parse(this.$route.query.detail)
      let num = 0
      let list = []
      detail.forEach((item, index) => {
        let obj = {
          skuGroupName: item.skuGroupName,
          skuGroupImage: item.skuGroupImage
        }
        // 生成请求数据
        this.addSkuGroupStepTwoVo.skuGroups.push(
          {
            onlineSamplePrice: '',
            startupsSamplePrice: '',
            samplePrice: '',
            sampleThemeList: [],
            sampleThemeIdSet: [],
            skuGroupId: item.id,
            skus: []
          }
        )
        let arr = item.dictIdSet.split(';')
        arr.pop()
        arr.forEach(val => {
          // 获得key和val的id
          let arr2 = val.split(':')
          // 获取详情
          this.attrNameList.forEach(item => {
            if (+arr2[0] === item.id) {
              dictGet(arr2[1]).then(res2 => {
                if (res2.data.success) {
                  num++
                  obj[item.key] = res2.data.data.propVal
                  list[index] = obj
                  if (num >= this.attrNameList.length * detail.length) {
                    this.skuList = list
                    this.$forceUpdate()
                  }
                }
              })
            }
          })
        })
      })
    },
    // ------------------------------------------------
    RowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 获取平台类型
    getPlatformType () {
      storeTypeGetStoreTypeList().then((res) => {
        this.platformType = res.data.data
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "./styles.less";
@deep: ~">>>";

.elinput {
  color: #666;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  height: 30px;
  padding: 0 15px;
  width: 100%;
  box-sizing: border-box;
  outline: none;
}
</style>
